module.exports = __webpack_public_path__ + "assets/img/main_icon_carousel_arrow_right.8a62e4c4.svg";